import React from "react";
import * as styles from "./relatedProductsDetail.module.scss";
import Button from "../../UI/Button/Button";
import Variant from "../../UI/Variant/variant";
import RightArrow from "../../../images/arrowRight.svg";
import img from "../../../images/recipes/recipes-01-img.png";
import img2 from "../../../images/recipes/recipes-02-img.png";
import img3 from "../../../images/recipes/recipes-03-img.png";

const productsData = [
  {
    imgSrc: img,
    variants: ["Fabrica de pastas", "Bebida"],
    title: "Bizcochuelo Matcha con Mousse de Chocolate",
  },
  {
    imgSrc: img2,
    variants: ["Licuadora de mano", "Bebida"],
    title: "Budín de Mandarina",
  },
  {
    imgSrc: img3,
    variants: ["Fabrica de pan", "Bebida"],
    title: "Pan de molde integral",
  },
];

const RelatedProductsDetail = ({ recipeRelated, name }) => {
  const dataToShow = recipeRelated || productsData;

  return (
    <section className={styles.relatedProductsDetailContainer}>
      <div className="container m0-auto">
        <div className={styles.relatedProductsDetail}>
          <h3>También puede interesarte</h3>
        </div>
      </div>

      <div className={styles.ourRecipes__container}>
        {dataToShow?.map((product, index) => {
          const variants = [];
          if (product.type) {
            variants.push(product.type);
          }
          if (product.category) {
            variants.push(product.category);
          }

          return (
            <div className={styles.ourRecipes__item} key={index}>
              <div className={styles.container_img}>
                <img
                  src={product.image}
                  className="img-fluid"
                  alt={`Product ${index + 1}`}
                />
              </div>

              <div className={styles.ourRecipes__variants}>
                {variants.map((variant, variantIndex) => (
                  <Variant text={variant} key={variantIndex} />
                ))}
              </div>
              <h4>{product.name}</h4>
              <a
                href={`/${name}/${product.slug}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ zIndex: 1 }}
              >
                <Button text="Ver más" icon={RightArrow} />
              </a>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default RelatedProductsDetail;
